"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCreatedAtKpi = exports.defaultDemographicsKpi = exports.defaultInternalKpi = exports.defaultRankingKpi = exports.defaultTierKpi = exports.defaultTotalPerPlayerKpi = void 0;
exports.defaultTotalPerPlayerKpi = {
    timeSpent: 0,
    rounds: 0,
    players: 0,
    retention: 0,
};
exports.defaultTierKpi = {
    timeSpent: 0,
    replayability: 0,
    popularity: 0,
    retention: 0,
    designEffort: 0,
};
exports.defaultRankingKpi = {
    timeSpent: 0,
    replayability: 0,
    popularity: 0,
    retention: 0,
};
exports.defaultInternalKpi = {
    timeSpent: 0,
    replayability: 0,
    popularity: 0,
    retention: 0,
};
exports.defaultDemographicsKpi = {
    '15-25': false,
    '25-35': false,
    '35-45': false,
    '>45': false,
    women: false,
    men: false,
};
exports.defaultCreatedAtKpi = '';
